import React from 'react'

function PlanListForm({
    translations,
    handleChange,
    handleSearchBar,
    texto,
    blockSearch,
    actionUrl,
}) {
    return (
        <form action={actionUrl} method="GET">
            <div
                id="searchbar"
                className={
                    !blockSearch
                        ? 'search-form-plan'
                        : 'search-form-hidden-plan'
                }
            >
                <input
                    aria-label="Search"
                    className={
                        !blockSearch
                            ? 'search-input-plan'
                            : 'search-hidden-plan'
                    }
                    id="busquedaPlan"
                    name="busquedaPlan"
                    placeholder={translations.ACCOUNTABILITY.PLAN_LIST_SEARCH}
                    type="text"
                    onChange={handleChange}
                    value={texto}
                />
                <button
                    aria-label="search plan"
                    className="button-no-style"
                    onClick={handleSearchBar}
                    title="search"
                    type="button"
                >
                    <i
                        title="search"
                        className={
                            !blockSearch
                                ? 'fa fa-search search-icon-plan'
                                : 'fa fa-search search-hidden-icon-plan'
                        }
                        aria-hidden="true"
                    />
                    <p className="hiddenParagraph-plan">Search</p>
                </button>
            </div>
        </form>
    )
}

export default PlanListForm
